import { render, staticRenderFns } from "./DonateModal.vue?vue&type=template&id=639fd6e2&lang=pug"
import script from "./DonateModal.vue?vue&type=script&lang=ts"
export * from "./DonateModal.vue?vue&type=script&lang=ts"
import style0 from "./DonateModal.vue?vue&type=style&index=0&id=639fd6e2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports